import MIndex from '@/views/mobile/index'
import MBind from '@/views/mobile/bind'
import MAccountStatus from '@/views/mobile/account_status'
import MUnBind from '@/views/mobile/unbind'
import MSample from '@/views/mobile/sample'
import Molecular from '@/views/mobile/molecular/index'
import MolecularOrderDetails from '@/views/mobile/molecular/order_details'
import MolecularSearch from '@/views/mobile/molecular/search'
import MolecularDeliver from '@/views/mobile/molecular/deliver'
import Gene from '@/views/mobile/gene/index'
import GeneOrderDetails from '@/views/mobile/gene/order_details'
import GeneSearch from '@/views/mobile/gene/search'
import Primer from '@/views/mobile/primer/index'
import PrimerOrderDetails from '@/views/mobile/primer/order_details'
import PrimerSearch from '@/views/mobile/primer/search'
import Sunger from '@/views/mobile/sunger/index'
import SungerOrderDetails from '@/views/mobile/sunger/order_details'
import SungerSearch from '@/views/mobile/sunger/search'
import Other from '@/views/mobile/other/index'
import OtherOrderDetails from '@/views/mobile/other/order_details'
import OtherSearch from '@/views/mobile/other/search'
import Agreement from '@/views/mobile/agreement'
const mobileRouter = [
  {
    path: '/mobile',
    name: 'Index',
    component: MIndex,
    meta: {
      title: '擎科生物',
      content: {
        keywords: '测序 引物  基因合成 分子试剂',
        description: '推动生物科技发展，让世界更美好'
      },
      requireAuth: true
    }
  },
  {
    path: '/mobile/login',
    name: 'MBind',
    component: MBind,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/mobile/account_status',
    name: 'AccountStatus',
    component: MAccountStatus,
    meta: {
      title: '账户状态'
    }
  },
  {
    path: '/unbind',
    name: 'MUnBind',
    component: MUnBind,
    meta: {
      title: '个人信息',
      requireAuth: true
    }
  },
  {
    path: '/sample',
    name: 'MSample',
    component: MSample,
    meta: {
      title: '发起取样',
      requireAuth: true
    }
  },
  {
    path: '/molecular',
    name: 'Molecular',
    component: Molecular,
    meta: {
      title: '分子产品',
      requireAuth: true
    }
  },
  {
    path: '/molecular/order_details',
    name: 'MolecularOrderDetails',
    component: MolecularOrderDetails,
    meta: {
      title: '订单详情',
      requireAuth: true
    }
  },
  {
    path: '/molecular/search',
    name: 'MolecularSearch',
    component: MolecularSearch,
    meta: {
      title: '搜索',
      requireAuth: true
    }
  },
  {
    path: '/molecular/deliver',
    name: 'MolecularDeliver',
    component: MolecularDeliver,
    meta: {
      title: '提交发货',
      requireAuth: true
    }
  },
  {
    path: '/gene',
    name: 'Gene',
    component: Gene,
    meta: {
      title: '基因合成',
      requireAuth: true
    }
  },
  {
    path: '/gene/order_details',
    name: 'GeneOrderDetails',
    component: GeneOrderDetails,
    meta: {
      title: '订单详情',
      requireAuth: true
    }
  },
  {
    path: '/gene/search',
    name: 'GeneSearch',
    component: GeneSearch,
    meta: {
      title: '搜索',
      requireAuth: true
    }
  },
  {
    path: '/primer',
    name: 'Primer',
    component: Primer,
    meta: {
      title: '引物合成',
      requireAuth: true
    }
  },
  {
    path: '/primer/order_details',
    name: 'PrimerOrderDetails',
    component: PrimerOrderDetails,
    meta: {
      title: '订单详情',
      requireAuth: true
    }
  },
  {
    path: '/primer/search',
    name: 'PrimerSearch',
    component: PrimerSearch,
    meta: {
      title: '搜索',
      requireAuth: true
    }
  },
  {
    path: '/sunger',
    name: 'Sunger',
    component: Sunger,
    meta: {
      title: 'sanger测序',
      requireAuth: true
    }
  },
  {
    path: '/sunger/order_details',
    name: 'SungerOrderDetails',
    component: SungerOrderDetails,
    meta: {
      title: '订单详情',
      requireAuth: true
    }
  },
  {
    path: '/sunger/search',
    name: 'SungerSearch',
    component: SungerSearch,
    meta: {
      title: '搜索',
      requireAuth: true
    }
  },
  {
    path: '/other',
    name: 'Other',
    component: Other,
    meta: {
      title: '其它项目',
      requireAuth: true
    }
  },
  {
    path: '/other/order_details',
    name: 'OtherOrderDetails',
    component: OtherOrderDetails,
    meta: {
      title: '订单详情',
      requireAuth: true
    }
  },
  {
    path: '/other/search',
    name: 'OtherSearch',
    component: OtherSearch,
    meta: {
      title: '搜索',
      requireAuth: true
    }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: Agreement,
    meta: {
      title: '用户协议'
    }
  }
]

mobileRouter.map(item => { item.meta.isMobile = true })

export default mobileRouter



// WEBPACK FOOTER //
// ./src/router/mobile.js